export default "__VITE_ASSET__ae9838eb__"